<script setup>
import { onMounted, ref } from "vue";
import AutoComplete from 'primevue/autocomplete';
import { carregarConceitos } from "@/api/fetchQuestoes";
import { extrairConceitosUnicos } from "@/utils/extrairConceitosUnicos";

const model = defineModel({ default: [] })
const conceitos = ref([]);
const sugestoesFiltradas = ref([]);
const loading = ref(false)

onMounted(async () => {
    let result = await carregarConceitos();
    if (result.data) {
        conceitos.value = extrairConceitosUnicos(result.data);
        sugestoesFiltradas.value = [...conceitos.value];
    }
});

const search = (event) => {
    let query = event.query;
    if (query && query.length > 2) {
        let filtered = conceitos.value.filter(conceito =>
            conceito.toLowerCase().startsWith(query.toLowerCase())
        );
        // Adicionar a própria query como sugestão se não houver correspondências
        if (filtered.length === 0) {
            filtered.push(query);
        }
        sugestoesFiltradas.value = filtered;
    } else {
        // Se a query for muito curta, resetar para a lista completa
        sugestoesFiltradas.value = [...conceitos.value];
    }
}

</script>

<template>
    <div class="p-fluid flex flex-column gap-2">
        <label>Tópicos</label>
        <AutoComplete v-model="model" multiple :suggestions="sugestoesFiltradas" @complete="search" class="w-full"
            :forceSelection="false" :loading="loading" />
    </div>
</template>